import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isKiosk } from "@/lib/kiosk";

export const useKiosk = () => {
  const [on, setOn] = useState(isKiosk);
  useEffect(() => { const f = () => setOn(isKiosk()); window.addEventListener("awg-kiosk", f); window.addEventListener("storage", f); return () => { window.removeEventListener("awg-kiosk", f); window.removeEventListener("storage", f); }; }, []);
  return on;
};

// While the device is in Vendor Market display mode, every non-vendor route is sent back to /vendor.
export const KioskGuard = ({ children }) => {
  const on = useKiosk();
  const { pathname } = useLocation();
  if (!on || pathname.startsWith("/vendor")) return children;
  const m = pathname.match(/^\/catalog\/([^/]+)$/);
  if (m) return <Navigate to={`/vendor/design/${m[1]}`} replace />;
  if (pathname === "/cart" || pathname === "/checkout") return <Navigate to="/vendor/checkout" replace />;
  return <Navigate to="/vendor" replace />;
};
